import { useClientInfo } from "frontend/subscriptions";
import { useRef, useState } from "react";
import style from "./more-board-active-users.module.css";
import { RW } from "shared/datamodel/replicache-wrapper/mutators";
import { SyncService } from "frontend/services/syncService";
import ActiveBoardUser from "./active-board-user";
import { Floater } from "frontend/ui-components/floaters/floater";
import { useOutsideRefs } from "frontend/utils/click-outside-handler";

export default function MoreBoardActiveUsers({
  syncService,
  clientIds,
  onClientIdSelected,
  followingClientId,
}: {
  syncService: SyncService<RW> | null;
  clientIds: string[];
  onClientIdSelected?: (clientId: string) => void;
  followingClientId: string | null;
}) {
  const [showPopup, setShowPopup] = useState(false);
  const ref = useRef<any>(null);
  const popupRef = useRef<any>(null);

  useOutsideRefs([ref, popupRef], () => setShowPopup(false));

  return (
    <>
      <div className={style.container} ref={ref} onClick={() => setShowPopup(true)}>
        <span>{clientIds.length}+</span>
      </div>
      {showPopup && (
        <Floater relativeTo={ref}>
          {/* <div className={style.arrow} /> */}
          <div className={style.popup} ref={popupRef}>
            <div className={style.listContainer}>
              {clientIds.map((id) => (
                <ActiveUserRow
                  key={id}
                  clientId={id}
                  syncService={syncService}
                  onSelected={() => onClientIdSelected?.(id)}
                  isFollowing={followingClientId === id}
                />
              ))}
            </div>
          </div>
        </Floater>
      )}
    </>
  );
}

function ActiveUserRow({
  clientId,
  syncService,
  onSelected,
  isFollowing,
}: {
  clientId: string;
  syncService: SyncService<RW> | null;
  onSelected?: () => void;
  isFollowing: boolean;
}) {
  const info = useClientInfo(syncService?.getReplicache(), clientId);
  return (
    <div className={style.row} onClick={onSelected}>
      <ActiveBoardUser clientID={clientId} syncService={syncService} isFollowing={isFollowing} />
      <span>{info?.userInfo.name}</span>
    </div>
  );
}
